import { Region } from './DomainUtils';
import { DOMAIN_INFO } from 'src/utils/WindowUtils';

export const zipCodeFormatters: { [region: string]: (zipCode: string, shippingCountry?: string | null) => string } = {
  [Region.NA]: (zipCode, shippingCountry) => {
    zipCode = zipCode.trim();
    // Check if it's Canada specifically
    if (shippingCountry && shippingCountry.toLowerCase() === 'ca') {
      // For Canadian postal codes, return the first 3 characters + space + next 2 characters (A1A 1A)
      if (zipCode.includes(' ')) {
        // Already has space, return-first 6 characters (A1A 1A)
        return zipCode.substring(0, 6);
      } else {
        // No space, add space after first 3 characters and return first 6
        return zipCode.substring(0, 3) + ' ' + zipCode.substring(3, 5);
      }
    }
    // For US and other NA countries, take the first 5 digits
    return zipCode.replace(/\D/g, '').substring(0, 5);
  },
  
  [Region.EU]: (zipCode, shippingCountry) => {
    zipCode = zipCode.trim();
    // Special handling for the Netherlands (NL) postal codes
    if (shippingCountry && shippingCountry.toLowerCase() === 'nl') {
      // For Dutch postal codes (e.g., "2405 VB"), return only the numeric part
      return zipCode.replace(/\D/g, '').substring(0, 4);
    }
    // Special handling for UK postal codes
    if (shippingCountry && (shippingCountry.toLowerCase() === 'gb' || shippingCountry.toLowerCase() === 'uk')) {
      // UK format: SW1A 1AA -> SW1A 1
      const parts = zipCode.split(' ');
      if (parts.length === 2) {
        return `${parts[0]} ${parts[1][0]}`;
      }
      // If no space and length >= 5, format as first 4 chars + space + 1 char
      if (zipCode.length >= 5) {
        return `${zipCode.substring(0, 4)} ${zipCode.substring(4, 5)}`;
      }
      // If a format is unexpected, return the first 5 characters as fallback
      return zipCode.substring(0, 5);
    }
    
    // Special handling for India (IN) zip code
    if (shippingCountry && shippingCountry.toLowerCase() === 'in') {
      // Indian zip code are 6 digits (e.g., 360005)
      return zipCode.substring(0, 6);
    }

    // Default EU handling for other countries - return first 5 characters
    return zipCode.substring(0, 5);
  },
  
  [Region.FE]: (zipCode, shippingCountry) => {
    zipCode = zipCode.trim();
    // Special handling for Japan (JP) postal codes
    if (shippingCountry && shippingCountry.toLowerCase() === 'jp') {
      // Japan format: XXX-XXXX -> XXX-XXX
      if (/^\d{3}-\d{4}$/.test(zipCode)) {
        return zipCode.substring(0, 7);
      }
      // If a format is unexpected, return as is
      return zipCode;
    }
    // Default FE handling for other countries (like Australia) - returns as is
    return zipCode;
  },
};

export function trimZipCode(zipCode: string, shippingCountry?: string | null): string {
  const region = DOMAIN_INFO?.region || Region.NA;
  const formatZipCode = zipCodeFormatters[region] || zipCodeFormatters[Region.NA];
  return formatZipCode(zipCode, shippingCountry);
}
